import {Injectable} from "@angular/core";
import {TaskViewModel} from "../system/admin-panel/Tasks/Model/TaskViewModel";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable()
export class TasksService {

  constructor(private client:HttpClient) {

  }

  public GetTasks(to,from) {
    var query =from == undefined ?to == undefined ? "" : "?to=" +to :
     to == undefined ? "?from=" +from : "?to=" +to + "&from=" +from;
    return this.client.get<any>("/ctrl/tasks" + query).pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(TaskViewModel.fromJS(item))
      }

      return result;
    }))
  }

  public DeleteTask(id) {
    return this.client.delete("/ctrl/tasks/" + id);
  }

  public CreateTask(model:TaskViewModel) {
    model.RouteId = (model.intTarget == "Route") ? model.RouteId : 0;
    model.ZoneId = (model.intTarget != "Point") ? model.ZoneId : 0;

    return this.client.post("/ctrl/tasks", model);
  }
  public EditTask(model:TaskViewModel) {
    model.RouteId = (model.intTarget == "Route") ? model.RouteId : 0;
    model.ZoneId = (model.intTarget != "Point") ? model.ZoneId : 0;

    return this.client.put("/ctrl/tasks", model);
  }
}
